import { useEffect, lazy, Suspense } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import { VoteBanner } from "./VoteBanner";
import { Toaster } from "sonner";
import { trackVisitor, getCookie } from "../lib/cookies";
import { api } from "../lib/api";

const Chatbot = lazy(() => import("./Chatbot").then((m) => ({ default: m.Chatbot })));

export const Layout = () => {
  const loc = useLocation();
  const isPreview = /^\/templates\/[^/]+\/preview$/.test(loc.pathname);
  useEffect(() => { trackVisitor(); }, []);
  useEffect(() => {
    window.scrollTo(0, 0);
    // Track SPA route changes in Google Analytics + Facebook Pixel
    const url = loc.pathname + loc.search;
    if (window.gtag) window.gtag("config", "G-WDMN3F1KXV", { page_path: url });
    if (window.fbq) window.fbq("track", "PageView");
    // Lightweight first-party visit tracking for the admin analytics dashboard.
    api.post("/track/visit", { path: loc.pathname, vid: getCookie("sawd_visitor"), ref: document.referrer }).catch(() => {});
  }, [loc.pathname, loc.search]);
  useEffect(() => {
    document.body.classList.toggle("preview-mode", isPreview);
    return () => document.body.classList.remove("preview-mode");
  }, [isPreview]);
  return (
    <div className="App min-h-screen flex flex-col">
      {isPreview ? (
        <Navbar sticky={false} />
      ) : (
        <div className="sticky top-0 z-50" data-testid="sticky-header">
          <VoteBanner />
          <Navbar sticky={false} />
        </div>
      )}
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      {!isPreview && <Suspense fallback={null}><Chatbot /></Suspense>}
      <Toaster position="top-center" richColors />
    </div>
  );
};
